import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PerformanceInsightsFooter = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <Styles.ChipsContainer>
        <Chip
          backgroundColor={theme.palette.orange.tone100}
          label={
            <Text type="bodyMonospaced" tag="span" color={theme.palette.orange.tone700}>
              {t('No incluye tu inversión en marketing u otros servicios digitales')}
            </Text>
          }
        />
        <Chip
          backgroundColor={theme.palette.orange.tone100}
          label={
            <Text type="bodyMonospaced" tag="span" color={theme.palette.orange.tone700}>
              {t('Aduanas solo en envíos internacionales')}
            </Text>
          }
        />
      </Styles.ChipsContainer>
      <Text type="bodySRegular" color={theme.colors.text.muted}>
        {t(
          'Tus datos reales · coste por fecha de envío · cifras orientativas para ayudarte a decidir, no un cierre contable.'
        )}
      </Text>
    </Styles.MainContainer>
  )
}

export default PerformanceInsightsFooter
